import { useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../App';

const useFetchData = ({ endpoint, setter, errorSetter, transformFn }) => {
  // Refs allow us to always access the latest function without making them
  // dependencies of useCallback – this prevents infinite re-fetch loops when
  // callers pass inline arrow functions (new reference on every render).
  const setterRef = useRef(setter);
  const errorSetterRef = useRef(errorSetter);
  const transformFnRef = useRef(transformFn);

  useEffect(() => { setterRef.current = setter; }, [setter]);
  useEffect(() => { errorSetterRef.current = errorSetter; }, [errorSetter]);
  useEffect(() => { transformFnRef.current = transformFn; }, [transformFn]);

  const fetchData = useCallback(() => {
    axios.get(`${API_BASE_URL}${endpoint}`)
      .then((res) => {
        const data = transformFnRef.current ? transformFnRef.current(res.data) : res.data;
        setterRef.current(data);
      })
      .catch((err) => {
        console.error(`Fehler beim Abrufen von ${endpoint}:`, err);
        if (errorSetterRef.current) errorSetterRef.current(`Fehler beim Laden: ${endpoint}`);
      });
  }, [endpoint]); // only re-create when the endpoint itself changes

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return fetchData;
};

export default useFetchData;